// 系统操作列表
const SystemOperationList = [
    {
        name: '拨打电话',
        remark: '该操作以H5的方式调用手机系统的拨号功能，视每个手机系统的差异调用界面会有差异',
        scene: '通过点击行为触发电话拨打；例如：展示用户信息的电话时，点击可以拨打该电话',
        ask: '需要传入符合要求的电话号码',
    },
    // {
    //     name: '拍照',
    //     remark: '该操作以H5的方式调用手机相机的拍照',
    //     scene: '通过点击按钮打开手机相机',
    //     ask: '--',
    // },
    // {
    //     name: '打开相册',
    //     remark: '该操作以H5的方式调用手机相册',
    //     scene: '通过点击按钮打开相册，选择相片',
    //     ask: '--',
    // },
    //     {
    //         name: '发送聊天消息',
    //         remark: '该操作支持企业微信/微信/钉钉，支持将特点内容作为图文消息发送到聊天窗口',
    //         scene: '某个操作流程需要其他人同事协助跟进或处理时，将内容发至与对发的群聊或聊天窗口',
    //         ask: `1、需要选择点击后业务页面
    // 2、配置消息标题
    // 3、配置消息图标`,
    //     },
    //     {
    //         name: '分享',
    //         remark: '支持调用App的通用分享能力',
    //         scene: '查看某个文章或内容觉得比较好，分享到社交媒体',
    //         ask: `1、分享的链接
    // 2、运行该H5的App自身需要完成微博、微信等社交媒体的分享接入`,
    //     },
    // {
    //     name: '创建对象',
    //     remark: '为实体对象创建一条数据',
    //     scene: '新增表单的保存',
    //     ask: '数据容器依赖的实体数据源',
    // },
    // {
    //     name: '删除对象',
    //     remark: '删除指定实体对象的数据',
    //     scene: '--',
    //     ask: '--',
    // },
    // {
    //     name: '保存修改',
    //     remark: '修改指定实体对象的数据',
    //     scene: '编辑表单的保存按钮事件',
    //     ask: '--',
    // },
    {
        name: '请求服务',
        remark: '调用注册到平台的后端操作(服务API)',
        scene: '自定义按钮操作需要操作业务数据时使用；例如：通过按钮操作删除某条记录',
        ask: '--',
    },
]

export {
    SystemOperationList,
}
